//@ts-check
import { getAll, get } from '../utilities/querySelector';
import { toggleBooleanAttribute } from '../utilities/attributes';

const accordions = getAll( '.accordion' );
const details = getAll( '.details' );

const open = Symbol( 'detail-item-open' );
const close = Symbol( 'detail-item-close' );
const toggle = Symbol( 'detail-item-toggle' );

/**
 * Set up the details js to toggle the details when clicked
 */
details.forEach( item => {
    const toggler = get( '.details__summary', item );
    item[open] = open_detail_item.bind( item );
    item[close] = close_detail_item.bind( item );
    item[toggle] = toggle_detail_item.bind( item );
    toggler.addEventListener( 'click', item[toggle] );
} );

/**
 * Set up accordion logic to close other tabs if one is opened
 */
accordions.forEach( accordion => {
    const items = getAll( '.details', accordion );
    items.forEach( item => {
        const toggler = get( '.details__summary', item );
        toggler.addEventListener( 'click', () => {
            items.forEach( item_b => {
                if ( item !== item_b ) item_b[close]();
            } );
        } );
    } );

} );

function open_detail_item() {
    this.setAttribute( 'aria-expanded', 'true' );
}

function toggle_detail_item() {
    toggleBooleanAttribute( 'aria-expanded', this );
}

function close_detail_item() {
    this.setAttribute( 'aria-expanded', 'false' );
}